import "../../../style/ModelGeneralPage/animation.css";
import "../../../style/ModelGeneralPage/tooltip.css";

import { Html, Preload } from "@react-three/drei";
import { Suspense, useEffect, useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { CameraControls } from "../logic/logic";
import { Modal } from "../../../../common/UI/Modal/molecules/Modal";
import { PhotoModalSecond } from "../../../../common/UI/Modal/molecules/ModalPhoto";
import { NavMenu } from "../../../../common/UI/NavMenu/organoids/NavMenu";
import { CameraTurnButton } from "../molecules/ButtonCameraTurn";
import { Scene } from "../molecules/Scene";
import { GuideButtons3D } from "../molecules/GuideButtons3D";
import { useStore } from "effector-react";
import {
  $ReadenModelSlides,
  AddReadenModelSlide,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import {
  Ipoint2D,
  Ipoint3D,
  ISetForModal,
} from "../../../../common/interfaces";
import { extend } from "@react-three/fiber";
import { titleName } from "../../../../common/function";
import { setmodelPage } from "../../../../common/hooks";
import { useTranslation } from "react-i18next";

import POINT from "../../../../common/assets/images/Cepr/ModelPage/Pointer.png";
import Cont_1_2 from "../../../../common/assets/images/Cepr/ModelPage/Панель мониторинга(подсистема хранения данных и визуализации).jpg";
import Cont_1_5 from "../../../../common/assets/images/Cepr/ModelPage/CEPR_open 2.jpg";
import Cont_1_6 from "../../../../common/assets/images/Cepr/ModelPage/CEPR_open 1.jpg";
import Cont_1_1_3 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_подсистема очистки СОЖ(маркер 2).jpeg";
import Cont_1_1_4 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_подсистема измерений(маркер 1).jpg";
import Cont_1_1_5 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_подсистема измерений(маркер 1) (2).jpg";
import Cont_1_1_6 from "../../../../common/assets/images/Cepr/ModelPage/Правая секиця_Подсистема управления(маркер 3).jpg";
import Cont_1_1_7 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_Подсистема управления(маркер 3)(2).jpeg";
import Cont_1_1_8 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_Подсистема циркуляции и гидрорегулирования(маркер 4).jpeg";
import Cont_1_1_9 from "../../../../common/assets/images/Cepr/ModelPage/Правая секция_Подсистема циркуляции и гидрорегулирования.jpeg";
import Cont_1_6_3 from "../../../../common/assets/images/Cepr/ModelPage/Левая секция_Система водоподготовки(маркер 1).jpg";
import Cont_1_6_4 from "../../../../common/assets/images/Cepr/ModelPage/Левая секция_Система водоподготовки(маркер2).jpg";
import Cont_1_6_5 from "../../../../common/assets/images/Cepr/ModelPage/Левая секция_Система дозирования присадок(маркер 3).jpg";
import Cont_1_7_1 from "../../../../common/assets/images/Cepr/ModelPage/Задняя секция_подсистема регулирования потоков жидкости 1.jpg";
import Cont_1_7_2 from "../../../../common/assets/images/Cepr/ModelPage/Задняя секция_подсистема регулирования потоков жидкости 2.jpg";
import Cont_1_7_3 from "../../../../common/assets/images/Cepr/ModelPage/Задняя секция_подсистема регулирования потоков жидкости 3.jpg";
import { CircularProgress } from "@mui/material";
import "../styles/ModelPagePWA.css";
extend({ CameraTurnButton });

export const ModelPagePWA = () => {
  const [hovered, setHover] = useState<boolean>(false);
  const [selected, setSelected] = useState<string>("");
  const [spreadMenu, setSpreadMenu] = useState<boolean>(false);
  const [forModal, setForModal] = useState<ISetForModal>({} as ISetForModal);
  const [active, setActive] = useState(false);
  const [activeSecond, setActiveSecond] = useState(false);
  const [modalPoints, setModalPoints] = useState<Ipoint2D[] | null>(null);
  const [helper, setHelper] = useState<boolean>(false);

  const readenModelSlides = useStore($ReadenModelSlides);
  const canvasRef = useRef();
  const { t } = useTranslation();
  const points3D: Ipoint3D[] = [
    {
      id: 1,
      img: Cont_1_5,
      imgArray: [Cont_1_5],
      posX: 95,
      posY: 0,
      posZ: 0,
      shortTitle: t("ModelPage.Section_1.Short_Title"),
      title: t("ModelPage.Section_1.Title"),
      text: "",
      points: [
        {
          id: 1,
          top: "37%",
          left: "59%",
          titletext: [""],
          title: t("ModelPage.Section_1.Points.Points_1.Title"),
          content: [Cont_1_1_4, Cont_1_1_5],
          text: [t("ModelPage.Section_1.Points.Points_1.Text")],
        },
        {
          id: 2,
          top: "57%",
          titletext: [""],
          left: "62%",
          title: t("ModelPage.Section_1.Points.Points_2.Title"),
          content: [Cont_1_1_3],
          text: [t("ModelPage.Section_1.Points.Points_2.Text")],
        },
        {
          id: 3,
          top: "32%",
          titletext: [""],
          left: "46%",
          title: t("ModelPage.Section_1.Points.Points_3.Title"),
          content: [Cont_1_1_7, Cont_1_1_6],
          text: [t("ModelPage.Section_1.Points.Points_3.Text")],
        },
        {
          id: 4,
          titletext: [""],
          top: "65%",
          left: "44%",
          title: t("ModelPage.Section_1.Points.Points_4.Title"),
          content: [Cont_1_1_8, Cont_1_1_9],
          text: [t("ModelPage.Section_1.Points.Points_4.Text")],
        },
      ],
    },
    {
      id: 2,
      img: Cont_1_2,
      imgArray: [Cont_1_2],
      posX: 0,
      posY: 75,
      posZ: 135,
      shortTitle: t("ModelPage.Section_2.Short_Title"),
      title: t("ModelPage.Section_2.Title"),
      text: t("ModelPage.Section_2.Text"),
      points: null,
    },
    {
      id: 3,
      img: t("ModelPage.Section_3.Picture"),
      imgArray: [t("ModelPage.Section_3.Picture")],
      posX: -50,
      posY: 135,
      posZ: 135,
      shortTitle: t("ModelPage.Section_3.Short_Title"),
      title: t("ModelPage.Section_3.Title"),
      text: ``,
      points: null,
    },

    {
      id: 4,
      img: Cont_1_6,
      imgArray: [Cont_1_6],
      posX: -100,
      posY: 0,
      posZ: 0,
      shortTitle: t("ModelPage.Section_4.Short_Title"),
      title: t("ModelPage.Section_4.Title"),
      text: "",
      points: [
        {
          id: 1,
          titletext: [""],
          top: "40%",
          left: "53%",
          title: t("ModelPage.Section_4.Points.Points_1.Title"),
          content: [Cont_1_6_3],
          text: [t("ModelPage.Section_4.Points.Points_1.Text")],
        },
        {
          id: 2,
          top: "40%",
          titletext: [""],
          left: "43%",
          title: t("ModelPage.Section_4.Points.Points_2.Title"),
          content: [Cont_1_6_4],
          text: [``],
        },
        {
          id: 3,
          top: "60%",
          titletext: [""],
          left: "53%",
          title: t("ModelPage.Section_4.Points.Points_3.Title"),
          content: [Cont_1_6_5],
          text: [t("ModelPage.Section_4.Points.Points_3.Text")],
        },
      ],
    },
    {
      id: 5,
      img: Cont_1_7_1,
      imgArray: [Cont_1_7_1, Cont_1_7_2, Cont_1_7_3],
      posX: 0,
      posY: 45,
      posZ: -135,
      shortTitle: t("ModelPage.Section_5.Short_Title"),
      title: t("ModelPage.Section_5.Title"),
      text: ``,
      points: null,
    },
  ];

  const points = points3D;

  setmodelPage(true);

  titleName(t("BrowserLine.ModelPage"));

  useEffect(() => {
    if (!active) {
      setForModal({
        title: "",
        img: "",
        imgArray: [""],
        posX: 0,
        posY: 0,
        text: [""],
        modalType: 0,
      });
      setSelected("");
    }
  }, [active]);

  const setPositionFor = (
    eX: number,
    eY: number,
    img: string,
    title: string,
    text: string,
    imgArray: string[],
    modalType: number,
    list?: { title: string; quotes: string[] }[]
  ) => {
    setForModal({
      title: title,
      img: img,
      imgArray: imgArray,
      posX: eX,
      posY: eY,
      text: [text],
      modalType: modalType,
      list: list,
    });
    setActive(true);
    setHover(true);
  };

  return (
    <div className="Canvas" style={{ backgroundColor: "rgba(236, 236, 236,1)", height: "100vh" }}>
      <div
        style={{
          height: "83vh",
          width: "auto",
          backgroundColor: "rgba(236, 236, 236,1)",
        }}
      >
        <div className="Page_BlockTitle">{t("VideoPage.Title")}</div>
        <Canvas //@ts-ignore
          ref={canvasRef}
          camera={{ fov: 30 }}
        >
          {/* <color attach="background" args={["rgba(236, 236, 236,1)"]} /> */}
          <Suspense
            fallback={
              <Html>
                <CircularProgress />
              </Html>
            }
          >
            <Scene
              setHelper={setHelper}
              setSelected={setSelected}
              setPosition={setPositionFor}
              selected={selected}
              setModalPoints={setModalPoints}
              points={points}
            />
            <Preload all />
          </Suspense>
          <CameraControls />
        </Canvas>
      </div>
      <PhotoModalSecond
        title={forModal.title}
        text={forModal.text}
        content={forModal.imgArray}
        active={activeSecond}
        setActive={setActiveSecond}
      />
      <GuideButtons3D
        spreadMenu={spreadMenu}
        setSpreadMenu={setSpreadMenu}
        ReadenMarkers={readenModelSlides}
        AddReadenMarker={AddReadenModelSlide}
        markers={points}
        setSelected={setSelected}
      />
      {helper ? (
        <img
          className="withGrayWaves"
          src={POINT}
          alt=""
          style={{
            position: "absolute",
            top: "50%",
            left: "30%",
            height: "40px",
          }}
        />
      ) : (
        <></>
      )}

      <div
        className={active ? "tooltip_main" : "tooltip_main_hidden"}
        style={active ? { zIndex: 6 } : {}}
        onClick={() => {
          setActive(false);
          setHover(true);
        }}
      >
        {/* <TooltipImage setActiveSecond={setActiveSecond} modalPoints={modalPoints} setHover={setHover}
                              active={active} setActive={setActive} img={forModal.img} title={forModal.title}
                              posX={forModal.posX} posY={forModal.posY} text={forModal.text}
                              modalType={forModal.modalType}/> */}
        <Modal
          active={hovered}
          setHover={setHover}
          image={[forModal.img]}
          points={modalPoints}
          title={forModal.title}
          list={forModal.list}
        />
      </div>
      <NavMenu nextUrl={""} backUrl={"/pwa/video"} visibleFlag={"/pwa/model"} />
    </div>
  );
};
